import { useState } from 'react';
import { default as axios } from '../axiosConfig';
import { API_UploadPhoto, API_UploadToImgHosting } from '../Assets/ApiUrlContainer';

const PeopleProfileUpload = ({ onUploadSuccess, isFileUpload = true, customUploadBtnClass = '' }) => {
	const [file, setFile] = useState(null);
	const [fileName, setFileName] = useState('');
	const [uploading, setUploading] = useState(false);
	const [fileUrl, setFileUrl] = useState('');

	const handleFileChange = (event) => {
		setFile(event.target.files[0]);
		setFileName(event.target.files[0]?.name || '');
	};

	const handleUpload = async () => {
		if (!file) {
			alert('Please choose a file first!');
			return;
		}

		setUploading(true);

		const formData = new FormData();
		formData.append('file', file);

		try {
			const response = await axios.post(API_UploadPhoto, formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			});

			if (response.data.success) {
				setFileUrl(response.data.fileLink);
				onUploadSuccess(response.data.fileLink);
			}
		} catch (error) {
			console.error('Upload failed:', error);
		}

		setUploading(false);
	};

	// https://stackoverflow.com/questions/62733308/how-to-use-imgbb-api-with-axios-in-react
	const handleImgbbUpload = async () => {
		if (!file) {
			alert('Please choose a file first!');
			return;
		}

		setUploading(true);

		const body = new FormData();
		body.set('key', process.env.REACT_APP_PHOTO_HOSTING_API_KEY);
		body.append('image', file);

		try {
			const response = await axios.post(API_UploadToImgHosting, body);

			if (response) {
				console.log(response);
				onUploadSuccess(response.data.data.display_url);
			}
		} catch (error) {
			console.error('Upload failed:', error);
		}

		setUploading(false);
	};

	return (
		<div className='uploadToGoogleDrive'>
			{isFileUpload && <p>Upload New File to Google Drive:</p>}
			<div className='uploadFileInputContainer'>
				<label htmlFor='file' className='browseFiles'>
					{fileName ? fileName : 'Browse Files'}
				</label>

				<input id='file' style={{ display: 'none' }} type='file' accept='image/*' onChange={handleFileChange} />

				<button
					onClick={isFileUpload ? handleUpload : handleImgbbUpload}
					disabled={uploading}
					className={`uploadPhotoBtn ${customUploadBtnClass}`}
				>
					{uploading ? 'Uploading...' : 'Upload'}
				</button>
			</div>

			{isFileUpload && fileUrl && <p>Uploaded!</p>}
		</div>
	);
};

export default PeopleProfileUpload;
